// Theme: electric-sand
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'electric-sand',
  name: 'ELECTRIC SAND',
  tagline: 'ELECTRIC SAND',
  description: 'Amarelo eletrico sobre areia escura com energia contida.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#1A1208', '#2A2010', '#FDE047', '#FEFCE8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 8px 20px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-electric-sand'
  },
  colorVars: {
    '--accent': '#FDE047',
    '--accent-foreground': '#1A1208',
    '--background': '#1A1208',
    '--border': '#8A7020',
    '--card': '#2A2010',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 56%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEFCE8',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1208',
    '--foreground': '#FEFCE8',
    '--hold-fill': '#FDE047',
    '--input': '#8A7020',
    '--modal-bg': '#1A1208',
    '--modal-border': '#8A7020',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A7020',
    '--muted-foreground': '#FEFCE8',
    '--nav-active': '#FDE047',
    '--nav-bg': '#2A2010',
    '--popover': '#2A2010',
    '--popover-foreground': '#FEFCE8',
    '--primary': '#FDE047',
    '--primary-foreground': '#1A1208',
    '--ring': '#FDE047',
    '--secondary': '#8A7020',
    '--secondary-foreground': '#FEFCE8',
    '--streak': '#FDE047',
    '--success': '#22c55e',
    '--success-foreground': '#1A1208',
    '--xp': '#FDE047',
    '--xp-bg': '#2A2010'
  },
  resolvedVars: {
    '--accent': '#FDE047',
    '--accent-foreground': '#1A1208',
    '--accent-foreground-hsl': '33 53% 7%',
    '--accent-foreground-oklch': 'from #1A1208 l c h',
    '--accent-hsl': '50 98% 64%',
    '--accent-oklch': 'from #FDE047 l c h',
    '--background': '#1A1208',
    '--background-hsl': '33 53% 7%',
    '--background-oklch': 'from #1A1208 l c h',
    '--border': '#8A7020',
    '--border-hsl': '45 62% 33%',
    '--border-oklch': 'from #8A7020 l c h',
    '--border-w': '1px',
    '--card': '#2A2010',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 56%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEFCE8',
    '--card-foreground-hsl': '55 92% 95%',
    '--card-foreground-oklch': 'from #FEFCE8 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--card-hsl': '37 45% 11%',
    '--card-oklch': 'from #2A2010 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1208',
    '--destructive-foreground-hsl': '33 53% 7%',
    '--destructive-foreground-oklch': 'from #1A1208 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FEFCE8',
    '--foreground-hsl': '55 92% 95%',
    '--foreground-oklch': 'from #FEFCE8 l c h',
    '--hold-fill': '#FDE047',
    '--hold-fill-hsl': '50 98% 64%',
    '--hold-fill-oklch': 'from #FDE047 l c h',
    '--input': '#8A7020',
    '--input-hsl': '45 62% 33%',
    '--input-oklch': 'from #8A7020 l c h',
    '--modal-bg': '#1A1208',
    '--modal-bg-hsl': '33 53% 7%',
    '--modal-bg-oklch': 'from #1A1208 l c h',
    '--modal-border': '#8A7020',
    '--modal-border-hsl': '45 62% 33%',
    '--modal-border-oklch': 'from #8A7020 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.22)',
    '--muted': '#8A7020',
    '--muted-foreground': '#FEFCE8',
    '--muted-foreground-hsl': '55 92% 95%',
    '--muted-foreground-oklch': 'from #FEFCE8 l c h',
    '--muted-hsl': '45 62% 33%',
    '--muted-oklch': 'from #8A7020 l c h',
    '--nav-active': '#FDE047',
    '--nav-active-hsl': '50 98% 64%',
    '--nav-active-oklch': 'from #FDE047 l c h',
    '--nav-bg': '#2A2010',
    '--nav-bg-hsl': '37 45% 11%',
    '--nav-bg-oklch': 'from #2A2010 l c h',
    '--popover': '#2A2010',
    '--popover-foreground': '#FEFCE8',
    '--popover-foreground-hsl': '55 92% 95%',
    '--popover-foreground-oklch': 'from #FEFCE8 l c h',
    '--popover-hsl': '37 45% 11%',
    '--popover-oklch': 'from #2A2010 l c h',
    '--primary': '#FDE047',
    '--primary-foreground': '#1A1208',
    '--primary-foreground-hsl': '33 53% 7%',
    '--primary-foreground-oklch': 'from #1A1208 l c h',
    '--primary-hsl': '50 98% 64%',
    '--primary-oklch': 'from #FDE047 l c h',
    '--radius': '10px',
    '--ring': '#FDE047',
    '--ring-hsl': '50 98% 64%',
    '--ring-oklch': 'from #FDE047 l c h',
    '--secondary': '#8A7020',
    '--secondary-foreground': '#FEFCE8',
    '--secondary-foreground-hsl': '55 92% 95%',
    '--secondary-foreground-oklch': 'from #FEFCE8 l c h',
    '--secondary-hsl': '45 62% 33%',
    '--secondary-oklch': 'from #8A7020 l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 8px 20px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#FDE047',
    '--streak-hsl': '50 98% 64%',
    '--streak-oklch': 'from #FDE047 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A1208',
    '--success-foreground-hsl': '33 53% 7%',
    '--success-foreground-oklch': 'from #1A1208 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(50 98% 64% / 0.15)',
    '--xp': '#FDE047',
    '--xp-bg': '#2A2010',
    '--xp-bg-hsl': '37 45% 11%',
    '--xp-bg-oklch': 'from #2A2010 l c h',
    '--xp-hsl': '50 98% 64%',
    '--xp-oklch': 'from #FDE047 l c h'
  }
}
